<template>
  <header>
    <div class="DesktopHeader-styles-app-bar-container DesktopHeader-styles-app-bar-container-tipico-desktop">
      <div class="DesktopHeader-styles-app-bar">
        <router-link :to="{name: 'Sportsbook'}" class="DesktopHeader-styles-home-tipico-logo active">
          <!--<img alt="Tipico Logo" width="90" :src="'/static/assets/img/'+app.name+'h.svg'"> -->
          <!-- <img alt="Tipico Logo" width="90" :src="'/static/assets/img/tiptobet.svg'"> -->
           <img alt="Tipico Logo" width="90" src="/static/assets/img/tipco.svg">
        </router-link>

        <div class="searchBox">
          <span @click="showSearch" class="search-icon" :class="'os-icon os-icon-search'" v-if="!['Casino', 'LiveCasino'].includes($route.name)"></span>
            <eventSearch v-on:selected="showSearch" :place="t.search_match" v-show="searchShow && !['Casino', 'LiveCasino'].includes($route.name)"/>
            <span @click="showSearch" v-show="searchShow" class="close-icon" :class="'os-icon os-icon-close'" v-if="!['Casino', 'LiveCasino'].includes($route.name)"></span>
        </div>

        <div class="CashierDesktopHeader-styles-product-links-container">
          <div class="Toolbar-styles-toolbar DesktopHeader-styles-tool-bar">
            <router-link v-for="(route, index) in $router.options.routes"
                         :key="route.id"
                         v-if="route.main == 1"
                         :class="($route.name == route.name) ? 'DesktopHeader-styles-active active'+route.name : route.name "
                         :to="(route.name) ? { name: route.name, params: route.params } : route.path">

              {{ t.fixture[route.lang] }}
            </router-link>
          </div>
        </div>

        <div class="CashierDesktopHeader-styles-account-links-container" v-if="session.uid > 0">
          <router-link :to="{name: 'error_payment_reseller'}" class="DesktopHeader-styles-deposit-button">
            <div>
              <div class="DesktopHeader-styles-text">{{ t.deposit_now }}</div>
              <div class="DesktopHeader-styles-balance">{{ session.balance | toMoney(session.currency) }}</div>
            </div>
          </router-link>
          <router-link :to="{name: 'my_bets'}" class="DesktopHeader-styles-menu-link">
            <img class="DesktopHeader-styles-menu-link-icon" src="/static/assets/img/mybets-white.svg" alt="meldung" height="20" width="22" />
            <span class="DesktopHeader-styles-menu-link-title">{{ t.my_bets }}</span>
          </router-link>
          <a href="javascript:;" class="DesktopHeader-styles-menu-link">
            <div class="MessagesIcon-styles-menu-link-icon"><img src="/static/assets/img/message-white.svg" alt="meldung" height="16" width="22" /></div>
            <span class="MessagesIcon-styles-menu-link-title">{{ t.message }}</span>
          </a>
          <router-link :to="{name: 'personal_informations'}" class="DesktopHeader-styles-menu-link">
            <span class="DesktopHeader-styles-icon-wrapper"><img class="DesktopHeader-styles-menu-link-icon" src="/static/assets/img/account-white.svg" alt="menu" height="22" width="22" /></span>
            <span class="DesktopHeader-styles-menu-link-title">{{ t.account }}</span>
          </router-link>
        </div>

        <router-link v-if="session.uid == 0" :to="{name: 'Register'}" id="Register" class="DesktopHeader-styles-button DesktopHeader-styles-primary-button">{{ t.register }}</router-link>
        <router-link v-if="session.uid == 0" :to="{name: 'Login'}" id="Login" class="DesktopHeader-styles-button DesktopHeader-styles-normal-button">{{ t.login }}</router-link>
      </div>
    </div>
  </header>
</template>

<script>
import eventSearch from "./components/sportsbook/widget/eventSearch";
export default {
  name: 'header',
  components: {eventSearch},
  data () {
    return {
      app: this.$root.app,
      t: this.$root.t,
      session: this.$root.session,
      searchShow: false
    }
  },
  mounted() {
    this.$bus.$on('Session', (payload) => {

      this.session = payload;

    });
  },
  methods: {
    showSearch () {
      this.searchShow = (this.searchShow) ? false : true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.MessagesIcon-styles-menu-link-icon>img {
  width: 22px;
  height: 20px !important;
  margin-bottom: 4px;
  opacity: .78;
}
.search-icon {
  color: white;
  font-size: 30px;
  position: absolute;
  top: 10px;
  cursor: pointer;
}

.close-icon {
  color: white;
  font-size: 20px;
  position: absolute;
  top: 16px;
  margin-left: 315px;
  cursor: pointer;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/Header.vue